import styles from './Services.module.css';

const Services = () => {
    const services = [
        {
            icon: (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 12L8 24L16 36M32 12L40 24L32 36" stroke="url(#gradient1)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    <rect x="20" y="20" width="8" height="8" fill="url(#gradient1)" opacity="0.5" />
                    <circle cx="24" cy="24" r="2" fill="#00ff9d" />
                    <defs>
                        <linearGradient id="gradient1" x1="8" y1="12" x2="40" y2="36">
                            <stop stopColor="#00ff9d" />
                            <stop offset="1" stopColor="#2e8b57" />
                        </linearGradient>
                    </defs>
                </svg>
            ),
            title: 'Création de site web',
            description: 'Sites vitrines, e-commerce, plateformes sur mesure',
            details: [
                'Conception responsive (mobile, tablette, desktop)',
                'Utilisation de CMS ou développement sur mesure',
                'Optimisation SEO dès la création'
            ]
        },
        {
            icon: (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M38 18C38 18 34 14 24 14C14 14 10 18 10 18" stroke="url(#gradient2)" strokeWidth="2.5" strokeLinecap="round" />
                    <path d="M10 30C10 30 14 34 24 34C34 34 38 30 38 30" stroke="url(#gradient2)" strokeWidth="2.5" strokeLinecap="round" />
                    <path d="M32 20L36 24L32 28" stroke="url(#gradient2)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                    <circle cx="24" cy="24" r="4" stroke="url(#gradient2)" strokeWidth="2" fill="none" />
                    <defs>
                        <linearGradient id="gradient2" x1="10" y1="14" x2="38" y2="34">
                            <stop stopColor="#00ff9d" />
                            <stop offset="1" stopColor="#2e8b57" />
                        </linearGradient>
                    </defs>
                </svg>
            ),
            title: 'Refonte et optimisation',
            description: 'Donnez une nouvelle vie à votre site existant',
            details: [
                'Audit complet des sites existants',
                'Refonte design et ergonomie',
                'Amélioration des performances (temps de chargement, UX)'
            ]
        },
        {
            icon: (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 36L16 28L24 32L40 16" stroke="url(#gradient3)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M32 16H40V24" stroke="url(#gradient3)" strokeWidth="2" strokeLinecap="round" />
                    <circle cx="16" cy="28" r="2" fill="#00ff9d" />
                    <circle cx="24" cy="32" r="2" fill="#00ff9d" />
                    <circle cx="40" cy="16" r="2" fill="#00ff9d" />
                    <defs>
                        <linearGradient id="gradient3" x1="8" y1="16" x2="40" y2="36">
                            <stop stopColor="#00ff9d" />
                            <stop offset="1" stopColor="#2e8b57" />
                        </linearGradient>
                    </defs>
                </svg>
            ),
            title: 'Web marketing et SEO',
            description: 'Boostez votre visibilité en ligne',
            details: [
                'Stratégie digitale adaptée au business',
                'Optimisation SEO on-page et off-page',
                'Audit de trafic et recommandations'
            ]
        },
        {
            icon: (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="8" y="8" width="32" height="32" rx="4" stroke="url(#gradient4)" strokeWidth="2" fill="none" />
                    <path d="M16 18C16 18 18 16 24 16C30 16 32 18 32 18" stroke="url(#gradient4)" strokeWidth="2" strokeLinecap="round" />
                    <circle cx="18" cy="26" r="2" fill="#00ff9d" />
                    <circle cx="30" cy="26" r="2" fill="#00ff9d" />
                    <path d="M18 32C18 32 20 34 24 34C28 34 30 32 30 32" stroke="url(#gradient4)" strokeWidth="2" strokeLinecap="round" />
                    <defs>
                        <linearGradient id="gradient4" x1="8" y1="8" x2="40" y2="40">
                            <stop stopColor="#00ff9d" />
                            <stop offset="1" stopColor="#2e8b57" />
                        </linearGradient>
                    </defs>
                </svg>
            ),
            title: 'Gestion des réseaux sociaux',
            description: 'Développez votre communauté',
            details: [
                'Création et planification de posts',
                'Community management',
                'Création de contenu visuel et vidéo (montage, IA)'
            ]
        },
        {
            icon: (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="24" cy="20" r="8" stroke="url(#gradient5)" strokeWidth="2" fill="none" />
                    <path d="M24 28L18 38M24 28L30 38M18 38H30" stroke="url(#gradient5)" strokeWidth="2" strokeLinecap="round" />
                    <path d="M20 16L24 12L28 16" stroke="url(#gradient5)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                    <defs>
                        <linearGradient id="gradient5" x1="16" y1="12" x2="32" y2="38">
                            <stop stopColor="#00ff9d" />
                            <stop offset="1" stopColor="#2e8b57" />
                        </linearGradient>
                    </defs>
                </svg>
            ),
            title: 'Identité visuelle / Graphisme',
            description: 'Un design unique pour votre marque',
            details: [
                'Création de logo',
                'Visuels pour le web et réseaux sociaux',
                'Illustrations ou images générées par IA'
            ]
        },
        {
            icon: (
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="12" y="8" width="24" height="32" rx="2" stroke="url(#gradient6)" strokeWidth="2" fill="none" />
                    <path d="M20 14H28M20 20H28M20 26H24" stroke="url(#gradient6)" strokeWidth="2" strokeLinecap="round" />
                    <circle cx="32" cy="32" r="8" fill="url(#gradient6)" />
                    <path d="M29 32L31 34L35 30" stroke="#0a0e0d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <defs>
                        <linearGradient id="gradient6" x1="12" y1="8" x2="40" y2="40">
                            <stop stopColor="#00ff9d" />
                            <stop offset="1" stopColor="#2e8b57" />
                        </linearGradient>
                    </defs>
                </svg>
            ),
            title: 'Maintenance et hébergement',
            description: 'Votre site entre de bonnes mains',
            details: [
                'Hébergement sécurisé et écologique',
                'Mises à jour régulières',
                'Support technique pour les clients'
            ]
        }
    ];

    return (
        <section id="services" className="section">
            <div className="container">
                <h2 className="section-title">Services / Offres</h2>

                <div className={styles.servicesGrid}>
                    {services.map((service, index) => (
                        <div
                            key={index}
                            className={styles.serviceCard}
                            style={{ animationDelay: `${index * 0.1}s` }}
                        >
                            <div className={styles.serviceIcon}>{service.icon}</div>
                            <h3 className={styles.serviceTitle}>{service.title}</h3>
                            <p className={styles.serviceDescription}>{service.description}</p>
                            <ul className={styles.serviceDetails}>
                                {service.details.map((detail, i) => (
                                    <li key={i}>
                                        <svg className={styles.checkmark} width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M3 8L6 11L13 4" stroke="#00ff9d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        {detail}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
